export const NAV_MENU_ITEMS = [
  {
    displayName: 'Dashboard',
    iconName: 'dashboard',
    route: 'dashboard',
    checkByName:'dashboard',
    depsRoutes : ['device']
  },
  {
    displayName: 'Asset Management',
    iconName: 'work',
    checkByName:'asset_mgmt',
    children: [
      {
        displayName: 'Sites',
        parent: 'Asset Management',
        route: 'asset-management/manage-wells'
      },
      {
        displayName: 'Equipment',
        parent: 'Asset Management',
        route: 'asset-management/manage-equipments',
        depsRoutes : ['view-equipment', 'edit-template', 'create-template' ]
      }
    ]
  },
  {
    displayName: 'Application',
    iconName: 'settings',
    checkByName:'org_mgmt',
    children: [
      {
        checkByName:'org_mgmt',
        displayName: 'Organization',
        parent: 'Application',
        route: 'application/manage-organization'
      },
      {
        checkByName: 'security',
        displayName: 'Security',
        parent: 'Application',
        route: 'application/manage-security',
      },
      {
        checkByName: 'hmi_access',
        displayName: 'HMI Access',
        parent: 'Application',
        route: 'application/manage-hmi',
      }
    ]
  }
]